import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from '../../context/TranslationContext.jsx';

const isPromise = (v) => v && typeof v === 'object' && typeof v.then === 'function';

export const TranslatedText = ({ text, dynamic = false }) => {
  const { tStatic, tEvent } = useTranslation();
  const src = useMemo(() => (typeof text === 'string' ? text : ''), [text]);
  const [value, setValue] = useState(dynamic ? src : tStatic(src));

  useEffect(() => {
    if (!dynamic) {
      setValue(tStatic(src));
      return;
    }

    let cancelled = false;
    const out = tEvent(src);

    if (!isPromise(out)) {
      setValue(out);
      return () => {
        cancelled = true;
      };
    }

    // Show original while translating.
    setValue(src);
    out
      .then((translated) => {
        if (!cancelled) setValue(typeof translated === 'string' ? translated : src);
      })
      .catch(() => {
        if (!cancelled) setValue(src);
      });

    return () => {
      cancelled = true;
    };
  }, [dynamic, src, tEvent, tStatic]);

  return <>{value}</>;
};
